import { ParamMap } from '@angular/router';
import { format } from 'date-fns';

import { DETAIL_PACKAGE_STEP } from '@packages/packages-search-bar/constants/package-flux-params';
import { PackageStep } from '@packages/packages-search-bar/constants/package-step';
import { isValidFormatJSON } from '@app/modules/core/mappers/is-json.mapper';
import { HotelDetailFluxType } from '@hotels/hotel-detail/entities/hotel-detail-type';
import { HotelDetailPackageResponse } from '@packages/packages-result/entities/hotel-detail';
import { HotelDetailResponse } from '@hotels/hotel-detail/entities/hotel-detail.response';
import { HOTEL_DETAIL_BASE_ROUTE } from '@hotels/hotel-detail/constants/hotel-detail-route-params';
import {
  getParamByPackResultURL, PACKAGES_RESULT_URL_PARAMS_POSITION, setBasePackageResultURL
} from '@packages/packages-result/mappers/package-routing.mapper';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';

export function isValidPackageStorageItem(item: string): boolean {
  return !!item && isValidFormatJSON(item);
}

export function getHotelDetailFluxType(params: ParamMap): HotelDetailFluxType {
  return isValidPackageDetailStep(params) ? HotelDetailFluxType.AIR_PACKAGE_HOTEL_DETAIL :
    HotelDetailFluxType.HOTEL_DETAIL;
}

export function isPackageHotelDetail(fluxType: HotelDetailFluxType): boolean {
  return fluxType === HotelDetailFluxType.AIR_PACKAGE_HOTEL_DETAIL;
}

export function searchByHotelDetail(isPackage: boolean): SearchBy {
  return isPackage ? SearchBy.PACKAGES : SearchBy.HOTELS;
}

export function isValidPackageDetailStep(params: ParamMap): boolean {
  return params?.get(DETAIL_PACKAGE_STEP) as PackageStep === PackageStep.AIR_PACK_HOTEL_DETAIL;
}

export function getDeeplinkUrlBySessionTokenUrl(detail: HotelDetailResponse, params: ParamMap): string {
  const _departureDate = format(new Date(detail?.Result?.CheckinDate), 'yyyy-MM-dd');
  const _arrivalDate = format(new Date(detail?.Result?.CheckoutDate), 'yyyy-MM-dd');
  return `/${HOTEL_DETAIL_BASE_ROUTE}/${detail?.Result?.HotelId}/${detail?.Result?.Destination}` +
    `/${_departureDate}/${_arrivalDate}/${params.get('rooms')}/${detail?.Result?.CurrencyCode}`;
}

export function setPackageResultUrlBySessionTokenUrl(
  detail: HotelDetailPackageResponse, params: ParamMap, resultUrl: string): string {
  const _departureDate = format(new Date(detail?.Result?.CheckinDate), 'yyyy-MM-dd');
  const _arrivalDate = format(new Date(detail?.Result?.CheckoutDate), 'yyyy-MM-dd');
  const departure = getParamByPackResultURL(resultUrl, PACKAGES_RESULT_URL_PARAMS_POSITION.DEPARTURE);
  const destination = getParamByPackResultURL(resultUrl, PACKAGES_RESULT_URL_PARAMS_POSITION.DESTINATION);
  const deeplink = `/${HOTEL_DETAIL_BASE_ROUTE}/${detail?.Result?.HotelCode}/${departure}/${destination}/${_departureDate}` +
    `/${_arrivalDate}/${params.get('rooms')}/${detail?.Result?.CurrencyCode}/${PackageStep.AIR_PACK_HOTEL_DETAIL}`;
  return setBasePackageResultURL(resultUrl, deeplink);
}
